module.exports = __webpack_public_path__ + "static/media/crof.bf861bc7.svg";